// Imports => Constants
import { ENDPOINTS } from '@constants';

export class UserAPI {
  constructor(Client, NoBaseClient, config) {
    this.Client = Client;
    this.NoBaseClient = NoBaseClient;
    this.config = config;
  }

  delete = () => {
    return this.Client.delete(
      ENDPOINTS.USER.DELETE,
    ).then((response) => response.data);
  };
}

export default UserAPI;
